import React, { FC } from 'react'

import { Button } from 'src/chrome'
import { AccountFragment, getCreditsBalance } from 'src/graphql'
import { PurchaseTypes } from 'src/payments/containers/Payment'
import { creditCardNeeded } from 'src/helpers'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'
import { useAccount, useQueries } from 'src/hooks'

interface BuyButtonProps {
  account: Pick<
    AccountFragment,
    'stripeSource' | 'shippingAddress' | 'points' | 'expense'
  >
  onPurchase: () => void
  order: OrderWithPartialLines | undefined
  purchaseType?: PurchaseTypes
  isUsingCredits?: true
}

const BuyButton: FC<BuyButtonProps> = props => {
  const {
    purchaseType,
    account,
    onPurchase: purchase,
    order,
    isUsingCredits,
  } = props
  const isNewUser = useAccount().username === ''
  const [credits] = useQueries(getCreditsBalance())
  const hasCardOnFile = !!account.stripeSource
  const isOrder = purchaseType === PurchaseTypes.ORDER
  const isBuyingAffiliate = purchaseType === PurchaseTypes.DISTRIBUTOR
  const isBuyingPlan = purchaseType === PurchaseTypes.PLAN
  const isAddressEmpty =
    !account.shippingAddress || !account.shippingAddress.address1
  const isDisabled: boolean =
    ((isBuyingAffiliate && !hasCardOnFile) ||
      (isBuyingPlan && !hasCardOnFile) ||
      (!isBuyingAffiliate && isAddressEmpty) ||
      (isOrder &&
        !!order &&
        creditCardNeeded(order, account, credits, !!isUsingCredits))) &&
    !isNewUser

  return (
    <div
      style={
        {
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
        } as React.CSSProperties
      }
    >
      {isAddressEmpty && !isBuyingAffiliate && (
        <span
          style={
            {
              marginRight: '20px',
              color: 'red',
              cursor: 'initial',
            } as React.CSSProperties
          }
        >
          Return Address Required
        </span>
      )}
      <Button
        id={'send_out_card_btn'}
        title={isOrder ? 'Send' : 'Buy'}
        buttonColor={isDisabled ? undefined : 'pink'}
        disabled={isDisabled}
        onClick={isDisabled ? () => {} : purchase}
        style={{ marginLeft: 'auto', width: 126 }}
      />
    </div>
  )
}

export default BuyButton
